
import filters from '@/filters';
import $ from 'jquery';
import axios from 'axios';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';

import UploadProgress from '@/components/candidate/UploadProgress.vue';
import FileDragInput from '@/components/input/FileDragInput.vue';
import PaginationMiniComponent from '@/components/paginations/ImportPagination.vue';
import UploadedFile from '@/components/candidate/UploadedFile.vue';
import ImportCandidateList from '@/components/candidate/ImportCandidateList.vue';

import CandidateService from '@/services/candidate.service';
import toast from '@/functions/toast.function';

const STATUS_INITIAL = 0;
const STATUS_TEMPLATE_DOWNLOADED = 1;
const STATUS_SUCCESS_UPLOAD = 2;
const STATUS_FAILED = 3;

@Component({
  components: {
    UploadProgress,
    FileDragInput,
    PaginationMiniComponent,
    ImportCandidateList,
    UploadedFile,
  },
  filters,
})
export default class Import extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectCandidateImportHistory', { namespace: 'candidate' })
  private actionSelectCandidateImportHistory: any;
  @Action('actionPaginationCandidateImportHistory', { namespace: 'candidate' })
  private actionPaginationCandidateImportHistory: any;

  // STATE
  @State('locale')
  private locale: string;
  @State('array_import', { namespace: 'candidate' })
  private array_import: any;
  @State('pagination_import', { namespace: 'candidate' })
  private pagination_import: any;

  /* INITIALIZATION */

  private files: any = null;
  private queueUploadProgress: any[] = [];
  private serviceCandidate: CandidateService = new CandidateService();
  private formFile: string = 'file/Format Data Import Candidate-v2.xlsx';
  private array_import_failed: any[] = [];
  private array_import_failed_pagination: any[] = [];
  private pageSize: number = 2;
  private array_uploaded: any[] = [];
  private currentStatus: number = STATUS_INITIAL;

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.clickPage(1);
  }

  /* METHOD */
  private isInitialize() {
    return this.currentStatus === STATUS_INITIAL;
  }
  private isDownloaded() {
    return this.currentStatus === STATUS_TEMPLATE_DOWNLOADED;
  }
  private isSuccessUpload() {
    return this.currentStatus === STATUS_SUCCESS_UPLOAD;
  }

  private clickPage(page: number) {
    this.array_import_failed_pagination.splice(0);
    for (let i = ((page - 1) * this.pageSize) ; i < ((page - 1) * this.pageSize) + this.pageSize ; i++) {
      if (i === this.array_import_failed.length) { break; }
      this.array_import_failed_pagination.push(this.array_import_failed[i]);
    }
  }

  private uploadProgress = (unique: number) => (progress: any) => {
    const percentage = Math.floor((progress.loaded * 100) / progress.total);
    $(`#${unique}`).find('progress').val(percentage);
  }

  private onChangeFile() {
    if (this.files.size > 0) {
      const unique = new Date().getTime();
      const params = new FormData();

      params.append('import_file', this.files);
      // params.append('unique', String(unique));

      const CancelToken = axios.CancelToken;
      let cancel = null;

      const config = {
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
        onUploadProgress: this.uploadProgress(unique),
      };

      this.serviceCandidate.serviceImportCandidate(params, config).then((response: any) => {
        if (response) {
          this.array_uploaded.push({ file: this.files, data: response.data });
          $(`#${unique}`).remove();
          if (response.data.success) {
            this.currentStatus = STATUS_SUCCESS_UPLOAD;
          } else {
            if (response.data.error) {
              if (this.locale === "en") {
                toast.error(response.data.error.en);
                return;
              } else {
                toast.error(response.data.error.id);
                return;
              }
            }
          }
          if (response.data.partial_error.length !== 0) {
            this.array_import_failed = response.data.partial_error;
            this.clickPage(1);
          }
        }
      });

      this.queueUploadProgress.push({
        file: this.files,
        unique,
        cancel,
      });
    }
    (this.$refs.fileImport as any).clear();
  }
}
